import { map } from 'lodash';
import moment from 'moment';
import React from 'react';
import { Button } from '@material-ui/core';
import { enqueueNotification } from '../reducers/notifications';

window._moment = moment;
export const dateFormatString = 'YYYY/MM/DD';
export const timeFormatString = 'HH:mm';

export const productionTime = (startedAt, finishedAt) => {
  let prodTime = '-';
  const parser = (t, u) => t ? `${t}${u}` : '';

  if (startedAt && finishedAt) {
    // Calculate in seconds first to handle sub-minute durations
    const seconds = moment(finishedAt).diff(moment(startedAt), 'seconds');
    let minutes = Math.floor(seconds / 60);

    // If less than 1 minute but greater than 0 seconds, show as 1 minute
    if (minutes === 0 && seconds > 0) {
      minutes = 1;
    }

    let hours = Math.floor(minutes / 60);
    minutes = minutes % 60;
    let days = Math.floor(hours / 24);
    hours = hours % 24;

    if (days) {
      prodTime = `${days}d ${ parser(hours, 'h') } ${ parser(minutes, 'm') }`;
    } else if (hours) {
      prodTime = `${hours}h ${ parser(minutes, 'm') }`;
    } else {
      prodTime = `${minutes}m`;
    }
  }

  return prodTime;
};

// eslint-disable-next-line import/prefer-default-export
export const formatProcesses = processes => {
  return map(processes, item => {
    const { started_at: startedAt, finished_at: finishedAt } = item;

    const timeStart =
        startedAt && moment(startedAt).isValid()
            ? moment
                .utc(startedAt)
                .local()
                .format('YYYY-MM-DD HH:mm:ss')
            : null;
    const timeEnd =
        finishedAt && moment(finishedAt).isValid()
            ? moment
                .utc(finishedAt)
                .local()
                .format('YYYY-MM-DD HH:mm:ss')
            : null;

    return {
      ...item,
      started_at: timeStart,
      finished_at: timeEnd,
      production_time: productionTime(timeStart, timeEnd) // TODO: Should move to BE
    };

  });
};

export const formatProcessesRequest = processes => {
  return map(processes, item => {
    let { started_at, finished_at } = item;
    const { id, user_id } = item;

    const fstring = 'YYYY-MM-DD HH:mm:ss';
    started_at = started_at ? moment.utc(started_at).format(fstring) : null;
    finished_at = finished_at ? moment.utc(finished_at).format(fstring) : null;

    return {
      id,
      user_id,
      started_at,
      finished_at
    };
  });
};

export const formatProcessRequest = process => {
  let { started_at: startedAt, finished_at: finishedAt } = process;
  const { id, user_id: userId } = process;

  if (startedAt && moment(startedAt).isValid()) {
    startedAt = moment(startedAt)
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  }

  if (finishedAt && moment(finishedAt).isValid()) {
    finishedAt = moment(finishedAt)
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  }

  return {
    id,
    user_id: userId,
    started_at: startedAt,
    finished_at: finishedAt
  };
};

export const formatProductionTime = seconds => {
  let minutes = seconds / 60;

  if (minutes < 1 && minutes > 0) {
    minutes = 1;
  }

  minutes = Math.ceil(minutes);

  if (!minutes) {
    return '';
  }

  let hours = 0;
  if (minutes > 60) {
    hours = minutes / 60;
  }

  if (hours) {
    minutes = (hours - parseInt(hours, 10)) * 60;
  }

  const time = [];

  hours = Math.floor(hours);
  minutes = Math.floor(minutes);

  if (hours) {
    time.push(`${hours}h`);
  }

  if (minutes) {
    time.push(`${minutes}m`);
  }

  return time.join(' ');
};

export const enqueueUnfinishedProcessNotification = error => {
  if (error.responseData) {
    if (
      error.responseData.patient &&
      error.responseData.message === 'User has another pending task.'
    ) {
      const message = (
        <div>
          You have an unfinished task.{' '}
          <Button
            color="primary"
            variant="contained"
            onClick={() => window.open(`/patient-workflow/${error.responseData.patient.id}`, '_blank')}
            size="small"
            style={{ marginLeft: 8 }}
          >
            GO TO PATIENT WORKFLOW
          </Button>
        </div>
      );
      return enqueueNotification('error', message);
    }
    return enqueueNotification('error', error.responseData.message);
  }

  return enqueueNotification('error', error.message);
};
